import  *  as CryptoJS from  'crypto-js';

export class Criptografar {
    private key : string='SCPEWEB';
    public encrypt(txt: string): string {
        return CryptoJS.AES.encrypt(txt, this.key).toString();
      }

      public decrypt(txtToDecrypt: string) {
        return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8);
      }
}
